import { useMutation } from '@gogame/query';

import { exportGridPA as key } from 'scenes/CustomAudiences/PartnerAudiences/data/queryKeyFactory';

import { exportGridPartnerAudiences } from 'scenes/CustomAudiences/PartnerAudiences/sources/partnerAudiences';

export const useExportGridPA = () => {
  const exportMutations = useMutation(key(), exportGridPartnerAudiences);

  return [exportMutations.mutateAsync, exportMutations];
};
